const HUBURL = 'https://tec2.laportal.net/api/publicHub';

export default {
    HUBURL,
}